import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Check from '../views/Check.vue'
import CourtSession from '../views/CourtSession.vue'
import VideoCall from '../views/VideoCall.vue'
import Sign from '../views/Sign.vue'
import SecretaryRecord from '../views/SecretaryRecord.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      token: false,
      title: '首页'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      token: false,
      title: '登录'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      token: false,
      title: '注册'
    }
  },
  {
    path: '/check',
    name: 'Check',
    component: Check,
    meta: {
      token: false,
      title: '验证邀请码'
    }
  },
  {
    path: '/court',
    name: 'CourtSession',
    component: CourtSession,
    meta: {
      token: true,
      title: '我的开庭'
    }
  },
  {
    path: '/sign',
    name: 'Sign',
    component: Sign,
    meta: {
      token: true,
      title: '笔录签名'
    }
  },
  {
    path: '/call',
    name: 'VideoCall',
    component: VideoCall,
    meta: {
      token: true,
      title: '开庭中'
    }
  },
  {
    path: '/secretary-record',
    name: 'SecretaryRecord',
    component: SecretaryRecord,
    meta: {
      token: true,
      title: '开庭笔录'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
